import { exhaustiveCheck } from '@/utils/exhaustive-check';
import { PaymentsFlowEntryPoint } from '../use-payment-flow';

export const getEntryPointPath = (entryPoint: PaymentsFlowEntryPoint) => {
  switch (entryPoint) {
    case 'BILL_PAY_UPLOAD_INVOICE':
      return '/payments';
    case 'INVOICE_PAGE':
      return '/invoice-pay';
    case 'TREASURY_PAGE_DEPOSIT':
    case 'TREASURY_PAGE_WITHDRAWAL':
      return '/treasury';
    case 'VIEW_ALL_BENEFICIARIES':
      return '/beneficiaries';
    default:
      return exhaustiveCheck(entryPoint);
  }
};
